// USED ON "SPECIAL PRODUCTS PAGES - BOTTLE NECK TAGS, DOOR HANGERS, CAR HANGERS, FOLDED TAGS"

class HTCalculatorStyled {
  constructor() {
    this.form = document.getElementById('ht-calculator-form');
    this.materialSelect = document.getElementById('ht-material-select');
    this.shapeSelect = document.getElementById('ht-shape-select');
    this.baseSelect = document.getElementById('ht-base-select');
    this.sizeSelect = document.getElementById('ht-size-select');
    this.quantitySelect = document.getElementById('ht-quantity-select');
    this.printSidesSelect = document.getElementById('ht-print-sides-select');
    this.printInkSelect = document.getElementById('ht-print-ink-select');
    this.printSidesLabel = document.querySelector('label[for="ht-print-sides-select"]');
    this.printInkLabel = document.querySelector('label[for="ht-print-ink-select"]');

    this.customQuantityField = document.getElementById('ht-custom-quantity-field');
    this.customQuantityInput = document.getElementById('ht-custom-quantity');
    
    this.drillDiameterSelect = document.getElementById('ht-drill-diameter-select');
    this.drillPositionSelect = document.getElementById('ht-drill-position-select');
    this.drillDiameterField = document.getElementById('ht-drill-diameter-field');
    this.stringAttachmentSelect = document.getElementById('ht-string-attachment-select');
    this.stringAttachmentField = document.getElementById('ht-string-attachment-field');
    this.stringTypeSelect = document.getElementById('ht-string-type-select');
    this.stringTypeFieldContainer = document.getElementById('ht-string-type-field');
    
    this.multipleDesignsInput = document.getElementById('ht-multiple-designs');
    this.variableDataSelect = document.getElementById('ht-variable-data-select');
    this.sequentialNumbersSelect = document.getElementById('ht-sequential-numbers-select');
    this.sequentialRangeInput = document.getElementById('ht-sequential-range');
    this.perforationCheckbox = document.getElementById('ht-perforation');
    this.designMyArtworkCheckbox = document.getElementById('ht-design-my-artwork');
    
    this.totalPriceDisplay = document.getElementById('ht-calculator-total-price');
    this.pricePerTagDisplay = document.getElementById('ht-calculator-price-per-tag');
    this.basePriceDisplay = document.getElementById('ht-calculator-base-price');
    this.setupCostDisplay = document.getElementById('ht-calculator-setup-cost');
    this.drillCostDisplay = document.getElementById('ht-calculator-drill-cost');
    this.stringCostDisplay = document.getElementById('ht-calculator-string-cost');
    this.priceSection = document.querySelector('.ht-calculator-price-section');
    
    this.pricingConstants = this.loadPricingConstants();
    this.stylesData = this.loadStyleTemplatesData();
    this.drillHoleData = this.loadDrillHoleData();
    this.drillHoleFoldedData = this.loadDrillHoleFoldedData();
    this.drillDiametersData = this.loadDrillDiametersData();
    this.drillPositionsData = this.loadDrillPositionsData();
    this.foilColorsData = this.loadFoilColorsData();
    
    this.cornerStyleSelect = document.getElementById('ht-corner-style-select-styled');
    this.cornerStyleField = document.getElementById('ht-corner-style-field-styled');
    this.cornerStylesData = this.loadCornerStylesData();

    this.lastCalculation = null;
    this.calculatorType = 'styled';
    this.originalMaterialOptions = null;
    this.pendingMaterialSelection = null;

    // Store original labels for foil toggle
    this.originalLabels = {
      printSides: this.printSidesLabel ? this.printSidesLabel.textContent : 'Printed Sides',
      printInk: this.printInkLabel ? this.printInkLabel.textContent : 'Printed Ink'
    };

    this.additionalOptionsDebounce = this.debounce(() => {
      this.calculatePriceIfReady();
    }, 100);
    
    this.init();
  }
  
  prepopulateFromSelections() {
    this.waitForDropdownReady(this.shapeSelect, () => {
      this.attemptStylePrepopulation();
    });
  }
  
  waitForDropdownReady(dropdown, callback, attempts = 0, maxAttempts = 10) {
    if (!dropdown) {
      return;
    }
    
    if (dropdown.options && dropdown.options.length > 1 && !dropdown.disabled) {
      callback();
    } else if (attempts < maxAttempts) {
      setTimeout(() => {
        this.waitForDropdownReady(dropdown, callback, attempts + 1, maxAttempts);
      }, 200);
    }
  }
  
  attemptStylePrepopulation() {
    try {
      let styleSelection = sessionStorage.getItem('selectedHTStyle');
      let sourceKey = 'selectedHTStyle';
      
      if (!styleSelection) {
        styleSelection = sessionStorage.getItem('selectedBottleNeckStyle');
        sourceKey = 'selectedBottleNeckStyle';
      }
      
      if (!styleSelection) {
        return;
      }
      
      const selection = JSON.parse(styleSelection);
      const matchIndex = this.findStyleMatchSimple(selection);
      
      if (matchIndex !== -1) {
        this.shapeSelect.selectedIndex = matchIndex;
        
        this.shapeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        this.shapeSelect.dispatchEvent(new Event('input', { bubbles: true }));
        
        this.shapeSelect.style.color = '#000';
        this.shapeSelect.blur();
        this.shapeSelect.focus();
        this.shapeSelect.blur();
        
        sessionStorage.removeItem(sourceKey);
        
        return true;
      } else {
        return false;
      }
      
    } catch (e) {
      return false;
    }
  }
  
  findStyleMatchSimple(selection) {
    const searchTerms = [
      selection.handle,
      selection.value, 
      selection.name
    ].filter(term => term && term.length > 0);
    
    for (let i = 0; i < this.shapeSelect.options.length; i++) {
      const option = this.shapeSelect.options[i];
      
      if (!option.value || option.value === '') {
        continue;
      }
      
      const optionValues = [
        option.value,
        option.textContent?.trim(),
        option.dataset.handle,
        option.dataset.styleName,
        option.dataset.productType
      ].filter(val => val && val.length > 0);
      
      for (const searchTerm of searchTerms) {
        for (const optionValue of optionValues) {
          if (this.simpleMatch(searchTerm, optionValue)) {
            return i;
          }
        }
      }
      
      for (const searchTerm of searchTerms) {
        for (const optionValue of optionValues) {
          if (this.simpleContains(searchTerm, optionValue)) {
            return i;
          }
        }
      }
    }
    
    return -1;
  }
  
  simpleMatch(a, b) {
    if (!a || !b) return false;
    return a.toString().toLowerCase().trim() === b.toString().toLowerCase().trim();
  }
  
  simpleContains(needle, haystack) {
    if (!needle || !haystack) return false;
    const needleLower = needle.toString().toLowerCase().trim();
    const haystackLower = haystack.toString().toLowerCase().trim();
    
    return haystackLower.includes(needleLower);
  }
  
  attemptBasePrepopulation() {
    try {
      const baseSelection = sessionStorage.getItem('selectedBase');
      if (!baseSelection) return true;
      
      const selection = JSON.parse(baseSelection);
      
      if (!this.baseSelect || this.baseSelect.disabled || this.baseSelect.options.length <= 1) {
        return false;
      }
      
      const matchIndex = this.findBaseMatchSimple(selection);
      if (matchIndex !== -1) {
        this.baseSelect.selectedIndex = matchIndex;
        this.baseSelect.dispatchEvent(new Event('change', { bubbles: true }));
        
        sessionStorage.removeItem('selectedBase');
        return true;
      }
      
      return false;
    } catch (e) {
      return true;
    }
  }
  
  findBaseMatchSimple(selection) {
    for (let i = 0; i < this.baseSelect.options.length; i++) {
      const option = this.baseSelect.options[i];
      if (!option.value) continue;
      
      if (this.simpleMatch(selection.handle, option.dataset.handle) ||
          this.simpleMatch(selection.value, option.value) ||
          this.simpleMatch(selection.name, option.textContent?.trim())) {
        return i;
      }
    }
    return -1;
  }
  
  attemptMaterialPrepopulation() {
    try {
      const materialSelection = sessionStorage.getItem('selectedMaterial');
      if (!materialSelection) return true;
      
      const selection = JSON.parse(materialSelection);
      
      if (!this.materialSelect || this.materialSelect.disabled || this.materialSelect.options.length <= 1) {
        this.pendingMaterialSelection = selection;
        
        setTimeout(() => {
          if (this.materialSelect && !this.materialSelect.disabled && this.materialSelect.options.length > 1) {
            this.attemptMaterialPrepopulation();
          }
        }, 200);
        
        return false;
      }
      
      const matchIndex = this.findMaterialMatchSimple(selection);
      if (matchIndex !== -1) {
        this.materialSelect.selectedIndex = matchIndex;
        
        this.updateSelectionState(this.materialSelect);
        
        requestAnimationFrame(() => {
          this.materialSelect.dispatchEvent(new Event('change', { bubbles: true }));
        });
        
        sessionStorage.removeItem('selectedMaterial');
        this.pendingMaterialSelection = null;
        return true;
      }
      
      return false;
    } catch (e) {
      return true;
    }
  }
  
  findMaterialMatchSimple(selection) {
    for (let i = 0; i < this.materialSelect.options.length; i++) {
      const option = this.materialSelect.options[i];
      if (!option.value) continue;
      
      if (this.simpleMatch(selection.handle, option.dataset.handle) ||
          this.simpleMatch(selection.value, option.value) ||
          this.simpleMatch(selection.name, option.textContent?.trim())) {
        return i;
      }
    }
    return -1;
  }
  
  checkPendingMaterialSelection() {
    if (this.pendingMaterialSelection && this.materialSelect && !this.materialSelect.disabled && this.materialSelect.options.length > 1) {
      this.attemptMaterialPrepopulation();
      return;
    }
    
    const storedMaterial = sessionStorage.getItem('selectedMaterial');
    const storedBase = sessionStorage.getItem('selectedBase');
    
    if ((storedMaterial || storedBase) && this.materialSelect && !this.materialSelect.disabled && this.materialSelect.options.length > 1) {
      this.attemptMaterialPrepopulation();
    }
  }

  init() {
    this.bindEvents();
    this.enableStyleTemplateFirst();
    this.resetOtherFields();
    this.hidePriceDisplay();
    
    document.dispatchEvent(new CustomEvent('calculator:ready', {
      detail: { calculatorType: 'styled' }
    }));

    setTimeout(() => {
      this.prepopulateFromSelections();
    }, 300);
      
    document.addEventListener('cart:item-added-success', () => {
      sessionStorage.removeItem('selectedMaterial');
      sessionStorage.removeItem('selectedBase');
      sessionStorage.removeItem('selectedHTStyle');
      sessionStorage.removeItem('selectedBottleNeckStyle');
      
      this.resetCalculator();
    });

    window.addEventListener('storage', (e) => {
      if (e.key === 'selectedBase' && e.newValue) {
        try {
          const baseData = JSON.parse(e.newValue);
          if (baseData.source === 'materials_carousel' && baseData.pending_material) {
            setTimeout(() => {
              this.attemptMaterialPrepopulation();
            }, 100);
          }
        } catch (e) {
          // Silent fail
        }
      }
    });
    
    document.addEventListener('materials-carousel:selection-changed', () => {
      setTimeout(() => {
        this.attemptMaterialPrepopulation();
      }, 100);
    });
  }
  
  loadPricingConstants() {
    try {
      const constantsScript = document.getElementById('ht-calculator-pricing-constants');
      const constants = constantsScript ? JSON.parse(constantsScript.textContent) : {};
      
      return {
        bleed_addition: constants.bleed_addition || 4,
        guillotine_setup_charge: constants.guillotine_setup_charge || 1000,
        guillotine_cutting_rate: constants.guillotine_cutting_rate || 45,
        digital_die_cut_setup_charge: constants.digital_die_cut_setup_charge || 1000,
        digital_die_cut_per_cut_charge: constants.digital_die_cut_per_cut_charge || 2,
        markup_percentage: constants.markup_percentage !== undefined ? constants.markup_percentage : 0,
        artwork_setup_charge: constants.artwork_setup_charge || 1000,
        guillotine_cuts_per_hour: constants.guillotine_cuts_per_hour || 120,
        guillotine_cutting_weight: constants.guillotine_cutting_weight || 300,
        guillotine_cutting_pile: constants.guillotine_cutting_pile || 100,
        service_charge: constants.service_charge || 1000,
        delivery_charge: constants.delivery_charge || 695,
        multiple_designs_per_design_charge: constants.multiple_designs_per_design_charge || 250,
        variable_data_setup_charge: constants.variable_data_setup_charge || 1000,
        sequential_data_setup: constants.sequential_data_setup || 1000,
        perforation_setup_charge: constants.perforation_setup_charge || 1000,
        perforation_per_1000_charge: constants.perforation_per_1000_charge || 1000,
        design_my_artwork: constants.design_my_artwork || 2500
      };
    } catch (error) {
      return {
        bleed_addition: 4,
        guillotine_setup_charge: 1000,
        guillotine_cutting_rate: 45,
        digital_die_cut_setup_charge: 1000,
        digital_die_cut_per_cut_charge: 2,
        markup_percentage: 0,
        artwork_setup_charge: 1000,
        guillotine_cuts_per_hour: 120,
        guillotine_cutting_weight: 300,
        guillotine_cutting_pile: 100,
        service_charge: 1000,
        delivery_charge: 695,
        multiple_designs_per_design_charge: 250,
        variable_data_setup_charge: 1000,
        sequential_numbers_setup: 1000,
        perforation_setup_charge: 1000,
        perforation_per_1000_charge: 1000
      };
    }
  }
  
  loadStyleTemplatesData() {
    try {
      const stylesScript = document.getElementById('ht-calculator-styles-data');
      if (!stylesScript) {
        return {};
      }
      
      const stylesData = JSON.parse(stylesScript.textContent);
      return stylesData;
    } catch (error) {
      return {};
    }
  }
  
  loadDrillHoleData() {
    try {
      const drillScript = document.getElementById('ht-calculator-drill-hole-data');
      if (!drillScript) {
        return {
          setup_charge: 2000,
          price_per_1000: 2000
        };
      }
      return JSON.parse(drillScript.textContent);
    } catch (error) {
      return {
        setup_charge: 2000,
        price_per_1000: 2000
      };
    }
  }

  loadDrillHoleFoldedData() {
    try {
      const script = document.getElementById('ht-calculator-drill-hole-folded-data');
      if (!script) {
        return {
          drill_hole_folded: {
            display_name: 'Drill Hole Folded 4mm',
            setup_charge: 1000,
            price_per_1000: 2000,
            handle: 'drill_hole_folded',
            product_types: ['folded_tag', 'bottle_neck_tag']
          }
        };
      }
      const data = JSON.parse(script.textContent);
      return data;
    } catch (error) {
      return {
        drill_hole_folded: {
          display_name: 'Drill Hole Folded 4mm',
          setup_charge: 1000,
          price_per_1000: 2000,
          handle: 'drill_hole_folded',
          product_types: ['folded_tag', 'bottle_neck_tag']
        }
      };
    }
  }

  loadDrillDiametersData() {
    try {
      const script = document.getElementById('ht-calculator-drill-diameters-data');
      if (!script) {
        return {
          '0': { 
            display_name: 'None', 
            value: 0, 
            handle: 'drill_hole_diameter_none' 
          },
          '4': { 
            display_name: '4mm', 
            value: 4, 
            handle: 'drill_hole_diameter_4mm' 
          }
        };
      }
      const data = JSON.parse(script.textContent);
      return data;
    } catch (error) {
      return {};
    }
  }

  loadDrillPositionsData() {
    try {
      const script = document.getElementById('ht-calculator-drill-positions-data');
      if (!script) {
        return {
          'top_left': { 
            display_name: 'Top Left', 
            code: 'top_left',
            handle: 'drill_hole_top_left',
            setup_charge: 1000,
            price_per_1000: 1000,
            folded_price_per_1000: 2000
          }
        };
      }
      const data = JSON.parse(script.textContent);
      return data;
    } catch (error) {
      return {};
    }
  }

  loadFoilColorsData() {
    try {
      const foilScript = document.getElementById('ht-calculator-foil-colours-data');
      if (!foilScript) {
        return {
          "silver_foil": {
            "display_name": "Silver Foil",
            "code": "silver_foil",
            "double_sided_foiling_rate": 0.60,
            "hex_color": "#C0C0C0",
            "handle": "silver_foil"
          },
          "gold_foil": {
            "display_name": "Gold Foil",
            "code": "gold_foil",
            "double_sided_foiling_rate": 0.60,
            "hex_color": "#FFD700",
            "handle": "gold_foil"
          }
        };
      }
      const data = JSON.parse(foilScript.textContent);
      return data;
    } catch (error) {
      return {
        "silver_foil": {
          "display_name": "Silver Foil",
          "code": "silver_foil",
          "artwork_charge": 1000,
          "double_sided_foiling_rate": 0.60,
          "hex_color": "#C0C0C0",
          "handle": "silver_foil"
        },
        "gold_foil": {
          "display_name": "Gold Foil",
          "code": "gold_foil",
          "artwork_charge": 1000,
          "double_sided_foiling_rate": 0.60,
          "hex_color": "#FFD700",
          "handle": "gold_foil"
        }
      };
    }
  }

  loadCornerStylesData() {
    try {
      const cornerScript = document.getElementById('ht-calculator-corner-styles-data');
      if (!cornerScript) {
        return {
          square: { display_name: 'Square Corners', price_per_1000: 0, setup_charge: 0, handle: 'square' },
          luggage: { display_name: 'Luggage Corners', price_per_1000: 1000, setup_charge: 1000, handle: 'luggage' },
          radius_2mm: { display_name: '2mm Radius', price_per_1000: 1000, setup_charge: 1000, handle: 'radius_2mm' },
          radius_7mm: { display_name: '7mm Radius', price_per_1000: 1500, setup_charge: 1000, handle: 'radius_7mm' }
        };
      }
      const data = JSON.parse(cornerScript.textContent);
      return data;
    } catch (error) {
      return {};
    }
  }

  checkCalculationReadiness() {
    const state = {
      hasStyleTemplate: !!(this.shapeSelect?.value && this.shapeSelect.value !== ''),
      hasBase: !this.baseSelect?.disabled && this.baseSelect?.options.length > 1 ? 
               !!(this.baseSelect?.value && this.baseSelect.value !== '') : true,
      hasMaterial: !!(this.materialSelect?.value && this.materialSelect.value !== ''),
      hasSize: !!(this.sizeSelect?.value && this.sizeSelect.value !== ''),
      hasQuantity: this.getCurrentQuantity() > 0,
      hasPrintSides: !!(this.printSidesSelect?.value && this.printSidesSelect.value !== ''),
      hasPrintInk: !!(this.printInkSelect?.value && this.printInkSelect.value !== '')
    };
    
    state.allReady = Object.values(state).every(v => v === true);
    
    return state;
  }

  enableStyleTemplateFirst() {
    this.shapeSelect.disabled = false;
    this.updateSelectionState(this.shapeSelect);
    
    this.baseSelect.disabled = true;
    this.materialSelect.disabled = true;
    this.sizeSelect.disabled = true;
    this.quantitySelect.disabled = true;
    this.printSidesSelect.disabled = true;
    this.printInkSelect.disabled = true;
    
    if (this.drillDiameterSelect) this.drillDiameterSelect.disabled = true;
    if (this.stringAttachmentSelect) this.stringAttachmentSelect.disabled = true;
    if (this.stringTypeSelect) this.stringTypeSelect.disabled = true;
    
    this.updateAllSelectionStates();
  }
  
  bindEvents() {
    this.shapeSelect.addEventListener('change', () => this.onStyleTemplateChange());
    this.baseSelect.addEventListener('change', () => this.onBaseChange());
    this.materialSelect.addEventListener('change', () => this.onMaterialChange());
    this.quantitySelect.addEventListener('change', () => this.onQuantityChange());
    this.printSidesSelect.addEventListener('change', () => this.onPrintSidesChange());
    this.printInkSelect.addEventListener('change', () => this.onPrintInkChange());
    
    if (this.customQuantityInput) {
      this.customQuantityInput.addEventListener('input', () => this.onCustomQuantityChange());
      this.customQuantityInput.addEventListener('change', () => this.onCustomQuantityChange());
    }
    
    if (this.drillDiameterSelect) {
      this.drillDiameterSelect.addEventListener('change', () => this.onDrillDiameterChange());
    }
    
    if (this.cornerStyleSelect) {
      this.cornerStyleSelect.addEventListener('change', () => this.onCornerStyleChange());
    }
    
    if (this.stringAttachmentSelect) {
      this.stringAttachmentSelect.addEventListener('change', () => this.onStringAttachmentChange());
    }
    
    if (this.stringTypeSelect) {
      this.stringTypeSelect.addEventListener('change', () => this.onStringTypeChange());
    }
    
    if (this.multipleDesignsInput) {
      this.multipleDesignsInput.addEventListener('input', () => this.onAdditionalOptionChange());
      this.multipleDesignsInput.addEventListener('change', () => this.onAdditionalOptionChange());
    }
    
    if (this.variableDataSelect) {
      this.variableDataSelect.addEventListener('change', () => this.onAdditionalOptionChange());
    }
    
    if (this.sequentialNumbersSelect) {
      this.sequentialNumbersSelect.addEventListener('change', () => this.onAdditionalOptionChange());
    }
    
    if (this.perforationCheckbox) {
      this.perforationCheckbox.addEventListener('change', () => this.onAdditionalOptionChange());
    }
    
    if (this.designMyArtworkCheckbox) {
      this.designMyArtworkCheckbox.addEventListener('change', () => {
        this.additionalOptionsDebounce();
      });
    }
  }
  
  onStyleTemplateChange() {
    const selectedStyleTemplate = this.shapeSelect.value;
    const styleOption = this.shapeSelect.selectedOptions[0];
    
    this.updateSelectionState(this.shapeSelect);
    
    if (selectedStyleTemplate && selectedStyleTemplate !== '') {
      this.baseSelect.disabled = false;
      this.updateSelectionState(this.baseSelect);
      this.attemptBasePrepopulation();      
      this.attemptMaterialPrepopulation();
      this.enableOptionalFieldsForStyleTemplate(styleOption);
      
      if (this.baseSelect.value) {
        const selectedBase = this.baseSelect.value;
        
        if (!this.originalMaterialOptions) {
          this.originalMaterialOptions = Array.from(this.materialSelect.options).slice();
        }
        
        const currentMaterialValue = this.materialSelect.value;
        this.materialSelect.innerHTML = '<option value="" hidden selected>Choose Material...</option>';
        
        const matchingMaterials = this.originalMaterialOptions.filter(option => {
          if (option.value === '') return false;
          const optionBaseHandle = option.dataset.baseHandle || '';
          return optionBaseHandle === selectedBase;
        });
        
        matchingMaterials.forEach(option => {
          this.materialSelect.appendChild(option.cloneNode(true));
        });
        
        if (currentMaterialValue) {
          const materialStillValid = Array.from(this.materialSelect.options)
            .some(opt => opt.value === currentMaterialValue);
          if (materialStillValid) {
            this.materialSelect.value = currentMaterialValue;
          }
        }
      }
    } else {
      this.resetBaseAndDown();
      this.resetOptionalFields();
    }
    
    this.calculatePriceIfReady();
  }
  
  onBaseChange() {
    const selectedBase = this.baseSelect.value;
    
    if (document.activeElement === this.materialSelect) {
      this.materialSelect.blur();
    }
    
    if (!this.originalMaterialOptions) {
      this.originalMaterialOptions = Array.from(this.materialSelect.options).slice();
    }
    
    this.updateSelectionState(this.baseSelect);
    
    if (selectedBase && selectedBase !== '') {
      if (!this.originalMaterialOptions) {
        this.originalMaterialOptions = Array.from(this.materialSelect.options).slice();
      }
      
      this.materialSelect.innerHTML = '<option value="" hidden selected>Choose Material...</option>';
      
      const matchingMaterials = this.originalMaterialOptions.filter(option => {
        if (option.value === '') return false;
        
        const optionBaseHandle = option.dataset.baseHandle || '';
        const isMatch = optionBaseHandle === selectedBase;
        
        return isMatch;
      });
      
      matchingMaterials.forEach(option => {
        this.materialSelect.appendChild(option.cloneNode(true));
      });

      // Force enable material dropdown immediately (before requestAnimationFrame)
      this.materialSelect.disabled = false;
      this.materialSelect.removeAttribute('disabled');

      requestAnimationFrame(() => {
        // Force enable again in requestAnimationFrame
        this.materialSelect.disabled = false;
        this.materialSelect.removeAttribute('disabled');
        this.updateSelectionState(this.materialSelect);

        const wizardMaterialField = document.getElementById('ht-wizard-material');
        if (wizardMaterialField) {
          // Force enable wizard field too
          wizardMaterialField.disabled = false;
          wizardMaterialField.removeAttribute('disabled');

          const fieldContainer = wizardMaterialField.closest('.ht-wizard-field');
          if (fieldContainer) {
            fieldContainer.classList.remove('ht-wizard-field--disabled');
            const disabledNote = fieldContainer.querySelector('.ht-wizard-field-note--disabled');
            if (disabledNote) {
              disabledNote.remove();
            }
          }
        }

        requestAnimationFrame(() => {
          this.checkPendingMaterialSelection();
        });
      });
    } else {
      if (this.originalMaterialOptions) {
        this.materialSelect.innerHTML = '';
        this.originalMaterialOptions.forEach(option => {
          this.materialSelect.appendChild(option.cloneNode(true));
        });
      }
      this.materialSelect.disabled = true;
      this.materialSelect.value = '';
      this.updateSelectionState(this.materialSelect);
      this.resetQuantityAndDown();
    }
    
    this.calculatePriceIfReady();
  }

  // Check if current material supports foil
  isFoilMaterial() {
    const materialOption = this.materialSelect.selectedOptions[0];
    return materialOption && materialOption.dataset.supportsFoil === 'true';
  }

  onMaterialChange() {
    const selectedMaterial = this.materialSelect.value;

    this.updateSelectionState(this.materialSelect);

    if (selectedMaterial && selectedMaterial !== '') {
      // Update labels based on foil status
      const isFoil = this.isFoilMaterial();
      if (this.printSidesLabel) {
        this.printSidesLabel.textContent = isFoil ? 'Foiled Sides' : this.originalLabels.printSides;
      }
      if (this.printInkLabel) {
        this.printInkLabel.textContent = isFoil ? 'Foiled Colour' : this.originalLabels.printInk;
      }

      this.sizeSelect.value = 'predefined';
      this.sizeSelect.disabled = false;
      this.updateSelectionState(this.sizeSelect);
      
      this.quantitySelect.disabled = false;
      this.updateSelectionState(this.quantitySelect);
      
      if (this.quantitySelect.value) {
        this.updatePrintOptionsForMaterial();
      }
    } else {
      this.resetQuantityAndDown();
    }
    
    this.calculatePriceIfReady();
  }
  
  updatePrintOptionsForMaterial() {
    const materialOption = this.materialSelect.selectedOptions[0];
    const isFoil = materialOption && materialOption.dataset.supportsFoil === 'true';
    
    const currentSides = this.printSidesSelect.value;
    const currentInk = this.printInkSelect.value;
    
    this.enablePrintOptions();
    
    if (currentSides) {
      const sideOption = Array.from(this.printSidesSelect.options)
        .find(opt => opt.value === currentSides);
      if (sideOption) {
        this.printSidesSelect.value = currentSides;
      }
    }
    
    if (currentInk) {
      const inkOption = Array.from(this.printInkSelect.options)
        .find(opt => opt.value === currentInk);
      if (inkOption) {
        this.printInkSelect.value = currentInk;
      }
    }
  }
  
  onQuantityChange() {
    const selectedQuantity = this.quantitySelect.value;

    this.updateSelectionState(this.quantitySelect);

    const currentPrintSides = this.printSidesSelect.value;
    const currentPrintInk = this.printInkSelect.value;
    const hasPrintSelections = currentPrintSides && currentPrintInk;

    if (selectedQuantity === 'custom') {
      if (this.customQuantityField) {
        this.customQuantityField.style.display = 'block';
      }
      if (this.customQuantityInput) {
        this.customQuantityInput.disabled = false;
        this.customQuantityInput.focus();
      }

      // Enable print options if material is selected (needed for state recovery)
      const hasMaterial = this.materialSelect.value && this.materialSelect.value !== '';

      if (hasMaterial) {
        // Material is selected - ensure print options are enabled
        if (hasPrintSelections) {
          // Print options already filled - ensure they stay enabled with values
          this.printSidesSelect.disabled = false;
          this.printInkSelect.disabled = false;
          this.updateSelectionState(this.printSidesSelect);
          this.updateSelectionState(this.printInkSelect);
        } else {
          // No selections yet but material is present - enable print options
          this.updatePrintOptionsForMaterial();
        }
      } else {
        // No material selected - reset print options
        this.resetPrintOptions();
      }

    } else {
      if (this.customQuantityField) {
        this.customQuantityField.style.display = 'none';
      }
      if (this.customQuantityInput) {
        this.customQuantityInput.disabled = true;
        this.customQuantityInput.value = '';
      }

      if (selectedQuantity && selectedQuantity !== '') {
        // For preset quantities, enable print options and restore selections
        const printOptionsDisabled = this.printSidesSelect.disabled || this.printInkSelect.disabled;

        if (printOptionsDisabled || !hasPrintSelections) {
          this.enablePrintOptions();

          if (currentPrintSides) {
            this.printSidesSelect.value = currentPrintSides;
            this.printSidesSelect.dispatchEvent(new Event('change'));
          }
          if (currentPrintInk) {
            this.printInkSelect.value = currentPrintInk;
            this.printInkSelect.dispatchEvent(new Event('change'));
          }
        }
        // else: print options already enabled with selections, leave them alone
      } else {
        this.resetPrintOptions();
      }
    }

    this.calculatePriceIfReady();
  }
  
  onCustomQuantityChange() {
    // Don't touch print options here - they were already set up in onQuantityChange()
    // Just recalculate the price with the new quantity value
    this.calculatePriceIfReady();
  }

  showCustomQuantityField() {
    if (this.customQuantityField) {
      this.customQuantityField.style.display = 'block';
    }
    if (this.customQuantityInput) {
      this.customQuantityInput.disabled = false;
    }
  }

  hideCustomQuantityField() {
    if (this.customQuantityField) {
      this.customQuantityField.style.display = 'none';
    }
    if (this.customQuantityInput) {
      this.customQuantityInput.disabled = true;
      this.customQuantityInput.value = '';
    }
  }
  
  enablePrintOptions() {
    const materialOption = this.materialSelect.selectedOptions[0];
    const isFoil = materialOption && materialOption.dataset.supportsFoil === 'true';
    
    this.printSidesSelect.disabled = false;
    this.printSidesSelect.innerHTML = isFoil ? 
      `<option value="" hidden>Choose Foiled Sides...</option>
       <option value="foil_side_single" data-multiplier="1" data-extra-charge="0">Single</option>
       <option value="foil_side_double" data-multiplier="2" data-extra-charge="1000">Double</option>` :
      `<option value="" hidden>Choose Printed Sides...</option>
       <option value="single" data-multiplier="1" data-extra-charge="0">Single Sided</option>
       <option value="double" data-multiplier="2" data-extra-charge="500">Double Sided</option>`;
    this.updateSelectionState(this.printSidesSelect);
    
    this.printInkSelect.disabled = false;
    
    if (isFoil) {
      this.printInkSelect.innerHTML = '<option value="" hidden>Choose Foil Colour...</option>';
      
      Object.entries(this.foilColorsData).forEach(([handle, foilColor]) => {
        const option = document.createElement('option');
        option.value = handle;
        option.textContent = foilColor.display_name || handle;
        
        option.dataset.artworkCharge = foilColor.artwork_charge || '1000';
        option.dataset.perSheetCost = foilColor.base_printing_cost || '0.1';
        
        const doubleSidedRaw = foilColor.double_sided_foiling_rate || 60;
        const doubleSidedPounds = doubleSidedRaw > 10 ? doubleSidedRaw / 100 : doubleSidedRaw;
        option.dataset.doubleSidedRate = doubleSidedPounds.toString();
        
        option.dataset.hexColor = foilColor.hex_color || '#C0C0C0';
        
        this.printInkSelect.appendChild(option);
      });
    } else {
      this.printInkSelect.innerHTML = `<option value="" hidden>Choose Printed Ink...</option>
       <option value="cmyk" data-artwork-charge="1000" data-per-sheet-cost="0.1">CMYK (Full Colour)</option>`;
      
      if (materialOption && materialOption.dataset.supportsWhiteInk === 'true') {
        const whiteInkOption = document.createElement('option');
        whiteInkOption.value = 'white_ink';
        whiteInkOption.textContent = 'White Ink';
        whiteInkOption.dataset.artworkCharge = '1000';
        whiteInkOption.dataset.perSheetCost = materialOption.dataset.priceWhiteInk || '0.4';
        this.printInkSelect.appendChild(whiteInkOption);
      }
    }
    
    this.updateSelectionState(this.printInkSelect);
  }
  
  onPrintSidesChange() {
    this.updateSelectionState(this.printSidesSelect);
    this.calculatePriceIfReady();
  }
  
  onPrintInkChange() {
    this.updateSelectionState(this.printInkSelect);
    this.calculatePriceIfReady();
  }
  
  onAdditionalOptionChange() {
    this.additionalOptionsDebounce();
  }
  
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  getStyleDimensions(styleOption) {
    const styleValue = styleOption.value;
    const productType = styleOption.dataset.productType;
    
    let width, height;
    
    switch(productType) {
      case 'folded_tag':
      case 'key_card_holder':
        width = parseFloat(styleOption.dataset.flatWidth);
        height = parseFloat(styleOption.dataset.flatHeight);
        break;
        
      case 'car_hanger':
        width = parseFloat(styleOption.dataset.width);
        height = parseFloat(styleOption.dataset.height);
        break;
        
      case 'bottle_neck_tag':
        width = parseFloat(styleOption.dataset.width);
        height = parseFloat(styleOption.dataset.height);
        break;
        
      case 'door_hanger':
        width = parseFloat(styleOption.dataset.width);
        height = parseFloat(styleOption.dataset.height);
        break;
        
      default:
        width = parseFloat(styleOption.dataset.width);
        height = parseFloat(styleOption.dataset.height);
    }
    
    if ((!width || !height || isNaN(width) || isNaN(height)) && this.stylesData) {
      const styleKey = `${productType}_${styleValue}`;
      const styleData = this.stylesData[styleKey];
      
      if (styleData) {
        if (productType === 'folded_tag' || productType === 'key_card_holder') {
          width = styleData.flat_width;
          height = styleData.flat_height;
        } else {
          width = styleData.width;
          height = styleData.height;
        }
      }
    }
    
    if (!width || !height || isNaN(width) || isNaN(height)) {
      width = 85;
      height = 55;
    }
    
    return { width, height, productType: productType || 'styled' };
  }
  
  determineCuttingMethod(productType) {
    const guillotineTypes = ['folded_tag'];
    const digitalTypes = ['bottle_neck_tag', 'door_hanger', 'car_hanger', 'key_card_holder'];
    
    if (guillotineTypes.includes(productType)) {
      return 'guillotine';
    } else {
      return 'digital';
    }
  }
  
  getSheetDimensions(cuttingMethod) {
    if (cuttingMethod === 'guillotine') {
      return {
        width: 434,
        height: 304,
        method: 'guillotine'
      };
    } else {
      return {
        width: 426,
        height: 296,
        method: 'digital'
      };
    }
  }
  
  calculateTagsPerSheet(width, height, sheetWidth, sheetHeight, productType, styleOption) {
    // Priority 1: Use metaobject preset tags_per_sheet if available (KCH requirement)
    if (styleOption) {
      const preset = parseInt(styleOption.dataset.tagsPerSheet);
      if (preset && preset > 0) {
        return preset;
      }
    }

    // Priority 2: existing formula (unchanged — gutter fix deferred to phase 2)
    const bleedAddition = productType === 'folded_tag' ?
      (this.pricingConstants.bleed_addition || 4) : 0;

    const effectiveWidth = width + bleedAddition;
    const effectiveHeight = height + bleedAddition;

    const portraitTags = Math.floor(sheetWidth / effectiveWidth) *
                        Math.floor(sheetHeight / effectiveHeight);
    const landscapeTags = Math.floor(sheetWidth / effectiveHeight) *
                         Math.floor(sheetHeight / effectiveWidth);

    const optimalTags = Math.max(portraitTags, landscapeTags, 1);

    return optimalTags;
  }
  
  calculateCuttingCharge(cuttingMethod, quantity, sheetsNeeded, materialOption, tagsPerSheet) {
    const constants = this.pricingConstants;
    
    if (cuttingMethod === 'guillotine') {
      const setupCharge = (constants.guillotine_setup_charge || 1000) / 100;
      const cuttingRate = constants.guillotine_cutting_rate || 45;
      const materialGsm = parseFloat(materialOption.dataset.materialWeight || materialOption.dataset.gsmOrMic) || 300;
      
      const cuttingPile = constants.guillotine_cutting_pile || 100;
      const defaultCuttingWeight = constants.guillotine_cutting_weight || 300;
      const guillotine_calc1 = Math.ceil((sheetsNeeded / cuttingPile) * (materialGsm / defaultCuttingWeight));
      
      const cutsPerHour = constants.guillotine_cuts_per_hour || 120;
      const guillotine_calc2 = guillotine_calc1 * (tagsPerSheet / cutsPerHour);
      
      const timeCost = guillotine_calc2 * cuttingRate;
      const totalCost = timeCost + setupCharge;
      
      return {
        setup: setupCharge,
        perQuantity: timeCost,
        total: totalCost
      };
    } else {
      const setupCostPence = constants.digital_die_cut_setup_charge || 1000;
      const setupCost = setupCostPence / 100;
      
      const perTagCuttingCost = (constants.digital_die_cut_per_cut_charge || 2) / 100;
      const totalCuttingCost = quantity * perTagCuttingCost;
      
      return {
        setup: setupCost,
        perQuantity: totalCuttingCost,
        total: setupCost + totalCuttingCost
      };
    }
  }  

  calculateSpecialFeatures(productType, styleOption, quantity) {
    let total = 0;
    const breakdown = [];
    
    if (productType === 'folded_tag' || productType === 'bottle_neck_tag' || productType === 'key_card_holder') {
      const numCreases = parseInt(styleOption.dataset.numCreases) || 1;
      const setupChargePence = parseFloat(styleOption.dataset.foldCreaseSetup) || 1000;
      const per1000ChargePence = parseFloat(styleOption.dataset.foldCreasePer1000) || 1000;

      // Shared formula for folded_tag, bottle_neck_tag, and key_card_holder:
      //   setup × numCreases + (qty / 1000) × per1000 × numCreases
      // numCreases counts the fold as crease #1. For folded_tag/bottle_neck_tag,
      // numCreases = 1 so behaviour is unchanged.
      const setupCost = (setupChargePence / 100) * numCreases;
      const quantityCost = ((quantity / 1000) * (per1000ChargePence / 100)) * numCreases;

      total = setupCost + quantityCost;
      breakdown.push({
        name: numCreases > 1 ? `Fold Crease (×${numCreases})` : 'Fold Crease',
        setup: setupCost,
        perQuantity: quantityCost,
        total: total
      });
    }
    
    return { total, breakdown };
  }
  
  calculateDrillHoleCost(quantity) {
    if (!this.drillDiameterSelect || !this.drillDiameterSelect.value || 
        this.drillDiameterSelect.value === 'none' || this.drillDiameterSelect.value === '') {
      return { setup: 0, perQuantity: 0, total: 0 };
    }
    
    const drillOption = this.drillDiameterSelect.selectedOptions[0];
    const isFoldedDrill = drillOption.dataset.isFolded === 'true';
    
    let setupChargePence, pricePerThousandPence;
    
    if (isFoldedDrill) {
      setupChargePence = parseInt(drillOption.dataset.setupCharge) || 1000;
      pricePerThousandPence = parseInt(drillOption.dataset.pricePer1000) || 2000;
    } else {
      setupChargePence = 1000;
      pricePerThousandPence = 1000;
      
      if (this.drillPositionSelect && this.drillPositionSelect.value && 
          this.drillPositionSelect.value !== '') {
        const positionOption = this.drillPositionSelect.selectedOptions[0];
        
        if (positionOption) {
          setupChargePence = parseInt(positionOption.dataset.setupCharge) || 1000;
          pricePerThousandPence = parseInt(positionOption.dataset.pricePerThousand) || 1000;
        }
      }
    }
    
    const setupCharge = setupChargePence / 100;
    const quantityCost = (quantity / 1000) * (pricePerThousandPence / 100);
    const total = setupCharge + quantityCost;
    
    return { setup: setupCharge, perQuantity: quantityCost, total: total };
  }

  calculateCornerStyleCost(quantity) {
    if (!this.cornerStyleSelect || !this.cornerStyleSelect.value || this.cornerStyleSelect.value === '') {
      return { setup: 0, perQuantity: 0, total: 0 };
    }
    
    const cornerOption = this.cornerStyleSelect.selectedOptions[0];
    const pricePerThousandPence = parseInt(cornerOption.dataset.pricePerThousand) || 0;
    const setupChargePence = parseInt(cornerOption.dataset.setupCharge) || 0;
    
    if (pricePerThousandPence === 0 && setupChargePence === 0) {
      return { setup: 0, perQuantity: 0, total: 0 };
    }
    
    const pricePerThousand = pricePerThousandPence / 100;
    const setupCharge = setupChargePence / 100;
    
    const quantityCost = (quantity / 1000) * pricePerThousand;
    const total = setupCharge + quantityCost;
    
    return { setup: setupCharge, perQuantity: quantityCost, total: total };
  }
  
  calculateStringCost(quantity) {
    const attachmentValue = this.stringAttachmentSelect ? this.stringAttachmentSelect.value : null;
    
    if (!attachmentValue || attachmentValue === '' || attachmentValue === 'none' || 
        attachmentValue.toLowerCase().includes('none')) {
      return { setup: 0, perQuantity: 0, total: 0 };
    }
    
    const attachmentOption = this.stringAttachmentSelect.selectedOptions[0];
    const typeOption = this.stringTypeSelect ? this.stringTypeSelect.selectedOptions[0] : null;
    
    const attachmentCostPence = parseInt(attachmentOption.dataset.attachmentCost) || 0;
    const attachmentCostPerThousand = attachmentCostPence / 100;
    const attachmentCost = (quantity / 1000) * attachmentCostPerThousand;
    
    let stringTypeCost = 0;
    if (typeOption && this.stringTypeSelect.value) {
      const pricePerString = parseFloat(typeOption.dataset.pricePerString) || 0;
      stringTypeCost = quantity * pricePerString;
    }
    
    const totalCost = attachmentCost + stringTypeCost;
    
    return { setup: 0, perQuantity: totalCost, total: totalCost };
  }
  
  calculateMultipleDesignsCost() {
    if (!this.multipleDesignsInput) return 0;
    
    const designCount = parseInt(this.multipleDesignsInput.value) || 0;
    if (designCount <= 1) return 0;
    
    const additionalDesigns = designCount - 1;
    const costPerDesign = (this.pricingConstants.multiple_designs_per_design_charge || 250) / 100;
    const totalCost = additionalDesigns * costPerDesign;
    
    return totalCost;
  }
  
  calculateVariableDataCost(quantity) {
    if (!this.variableDataSelect || this.variableDataSelect.value !== 'yes') return 0;
    
    const setupChargePence = this.pricingConstants.variable_data_setup || 1000; 
    const setupCharge = setupChargePence / 100;
    
    const totalCost = setupCharge;
    
    return totalCost;
  }
  
  calculateSequentialDataCost(quantity) {
    if (!this.sequentialNumbersSelect || this.sequentialNumbersSelect.value !== 'yes') return 0;
    
    const setupChargePence = this.pricingConstants.sequential_numbers_setup || 1000;
    const setupCharge = setupChargePence / 100;
    
    const totalCost = setupCharge;
    
    return totalCost;
  }
  
  calculatePerforationCost(quantity) {
    if (!this.perforationCheckbox || !this.perforationCheckbox.checked) return 0;
    
    const setupChargePence = this.pricingConstants.perforation_setup_charge || 1000;
    const per1000ChargePence = this.pricingConstants.perforation_per_1000_charge;
    
    const validPer1000 = (per1000ChargePence && !isNaN(per1000ChargePence)) ? per1000ChargePence : 1000;
    
    const setupCharge = setupChargePence / 100;
    const per1000Charge = validPer1000 / 100;
    const quantityCost = (quantity / 1000) * per1000Charge;
    const totalCost = setupCharge + quantityCost;
    
    return totalCost;
  }

  calculateDesignMyArtworkCost() {
    if (!this.designMyArtworkCheckbox || !this.designMyArtworkCheckbox.checked) return 0;
    
    const designServicePence = this.pricingConstants.design_my_artwork || 2500;
    const totalCost = designServicePence / 100;
    
    return totalCost;
  }
  
  parsePrice(priceString) {
    if (!priceString) return 0;
    
    const cleanPrice = priceString.toString()
      .replace(/[£$€]/g, '')
      .replace(/GBP/g, '')
      .replace(/,/g, '')
      .trim();
    
    const parsed = parseFloat(cleanPrice);
    return isNaN(parsed) ? 0 : parsed;
  }
  
  roundToPence(amount) {
    return Math.round((amount || 0) * 100) / 100;
  }
  
  calculatePriceIfReady() {
    const hasStyleTemplate = this.shapeSelect.value && this.shapeSelect.value !== '';
    const hasBase = !this.baseSelect.disabled && this.baseSelect.options.length > 1 ? 
                    (this.baseSelect.value && this.baseSelect.value !== '') : 
                    true;
    const hasMaterial = this.materialSelect.value && this.materialSelect.value !== '';
    const hasSize = this.sizeSelect.value && this.sizeSelect.value !== '';
    const hasQuantity = this.getCurrentQuantity() > 0;
    const hasPrintSides = this.printSidesSelect.value && this.printSidesSelect.value !== '';
    const hasPrintInk = this.printInkSelect.value && this.printInkSelect.value !== '';
    
    if (hasStyleTemplate && hasBase && hasMaterial && hasSize && hasQuantity && hasPrintSides && hasPrintInk) {
      this.calculatePrice();
      this.showPriceDisplay();
    } else {
      this.hidePriceDisplay();
    }
  }
  
  getCurrentQuantity() {
    const quantityValue = this.quantitySelect.value;
    
    if (quantityValue === 'custom') {
      const customValue = this.customQuantityInput ? parseInt(this.customQuantityInput.value) : 0;
      return customValue >= 25 ? customValue : 0;
    }
    
    return parseInt(quantityValue) || 0;
  }
  
  calculatePrice() {
    const materialOption = this.materialSelect.selectedOptions[0];
    const styleOption = this.shapeSelect.selectedOptions[0];
    const quantity = this.getCurrentQuantity();
    
    const { width, height, productType } = this.getStyleDimensions(styleOption);
    const cuttingMethod = this.determineCuttingMethod(productType);
    const sheetDimensions = this.getSheetDimensions(cuttingMethod);
    
    const tagsPerSheet = this.calculateTagsPerSheet(
      width,
      height,
      sheetDimensions.width,
      sheetDimensions.height,
      productType,
      styleOption
    );
    
    const sheetsNeeded = Math.ceil(quantity / tagsPerSheet);
    
    const baseCostPence = this.parsePrice(materialOption.dataset.baseCost) || 0;
    const baseCostPer1000Sheets = baseCostPence / 100;
    const materialPricePerSheet = baseCostPer1000Sheets / 1000;
    const materialCost = this.roundToPence(materialPricePerSheet * sheetsNeeded);
    
    const setupCostPence = this.parsePrice(materialOption.dataset.setupCost) || 0;
    const materialSetupCost = setupCostPence / 100;
    
    const printSidesOption = this.printSidesSelect.selectedOptions[0];
    const printInkOption = this.printInkSelect.selectedOptions[0];
    const printSidesExtraChargePence = this.parsePrice(printSidesOption.dataset.extraCharge) || 0;
    const printSidesExtraCharge = printSidesExtraChargePence / 100;

    const isFoil = materialOption && materialOption.dataset.supportsFoil === 'true';

    // Use priceCmykFoil from material for foil, perSheetCost from ink for non-foil
    let inkPerSheetCost;
    if (isFoil) {
      const priceCmykFoilRaw = materialOption.dataset.priceCmykFoil || '0.1';
      inkPerSheetCost = parseFloat(priceCmykFoilRaw) > 1 ? parseFloat(priceCmykFoilRaw) / 100 : parseFloat(priceCmykFoilRaw);
    } else {
      const inkPerSheetCostRaw = parseFloat(printInkOption.dataset.perSheetCost);
      inkPerSheetCost = isNaN(inkPerSheetCostRaw)
        ? 0.1
        : (inkPerSheetCostRaw > 1 ? inkPerSheetCostRaw / 100 : inkPerSheetCostRaw);
    }

    // Apply print sides multiplier for both foil and non-foil (matches regular calculator)
    const printSidesMultiplier = parseFloat(printSidesOption.dataset.multiplier) || 1;
    const basePrintingCost = this.roundToPence(sheetsNeeded * inkPerSheetCost * printSidesMultiplier);

    let foilingCost = 0;
    if (isFoil) {
      const foilColor = printInkOption;
      
      if (printSidesOption.value === 'foil_side_double') {
        const doubleSidedRate = parseFloat(foilColor.dataset.doubleSidedRate) || 0.60;
        foilingCost = this.roundToPence(sheetsNeeded * doubleSidedRate);
      } else {
        foilingCost = 0;
      }
    }

    const printingCost = basePrintingCost + foilingCost;
    const inkArtworkChargePence = this.parsePrice(printInkOption.dataset.artworkCharge) || 1000;
    const inkArtworkCharge = inkArtworkChargePence / 100;
    
    const cuttingCharge = this.calculateCuttingCharge(
      cuttingMethod, 
      quantity, 
      sheetsNeeded,
      materialOption,
      tagsPerSheet
    );
    
    const specialFeatureCosts = this.calculateSpecialFeatures(
      productType, 
      styleOption, 
      quantity
    );
    
    const drillHoleCost = this.calculateDrillHoleCost(quantity);
    const cornerStyleCost = this.calculateCornerStyleCost(quantity);
    const stringCost = this.calculateStringCost(quantity);
    
    const multipleDesignsCost = this.calculateMultipleDesignsCost();
    const variableDataCost = this.calculateVariableDataCost(quantity);
    const sequentialDataCost = this.calculateSequentialDataCost(quantity);
    const perforationCost = this.calculatePerforationCost(quantity);
    const designMyArtworkCost = this.calculateDesignMyArtworkCost();
    
    const totalAdditionalOptions = this.roundToPence(
      multipleDesignsCost + 
      variableDataCost + 
      sequentialDataCost + 
      perforationCost + 
      designMyArtworkCost
    );
    
    // Key Card Holder flat service charge (per product policy, all styles, all quantities).
    // Other styled products (folded_tag, bottle_neck_tag, car_hanger, door_hanger) remain 0.
    // Must match server-side branch in pricing-engine.js calculateServiceCharge().
    const serviceCharge = productType === 'key_card_holder'
      ? (this.pricingConstants.service_charge || 1000) / 100
      : 0;
    const deliveryCharge = (this.pricingConstants.delivery_charge || 695) / 100;

    const netTotal = this.roundToPence(
      materialCost +
      materialSetupCost +
      printingCost +
      printSidesExtraCharge +
      inkArtworkCharge +
      cuttingCharge.total +
      specialFeatureCosts.total +
      drillHoleCost.total +
      cornerStyleCost.total +
      stringCost.total +
      totalAdditionalOptions +
      serviceCharge +
      deliveryCharge
    );
    
    const markupRate = this.pricingConstants.markup_percentage / 100 || 0;
    const markupAmount = this.roundToPence(netTotal * markupRate);
    const priceExclVAT = this.roundToPence(netTotal + markupAmount);
    const vatAmount = this.roundToPence(priceExclVAT * 0.20);
    const priceInclVAT = this.roundToPence(priceExclVAT + vatAmount);
    const finalPricePerTag = this.roundToPence(priceInclVAT / quantity);
    
    this.updatePriceDisplay(
      materialCost + printingCost,
      materialSetupCost + inkArtworkCharge + cuttingCharge.total + specialFeatureCosts.total + totalAdditionalOptions + serviceCharge,
      drillHoleCost.total,
      stringCost.total,
      priceInclVAT,
      finalPricePerTag
    );
    
    this.lastCalculation = {
      tagWidth: width,
      tagHeight: height,
      productType: productType,
      tagsPerSheet: tagsPerSheet,
      sheetsNeeded: sheetsNeeded,
      cuttingMethod: cuttingMethod,
      sheetWidth: sheetDimensions.width,
      sheetHeight: sheetDimensions.height,
      materialCost: materialCost,
      materialSetupCost: materialSetupCost,
      printingCost: printingCost,
      inkArtworkCharge: inkArtworkCharge,
      cuttingCost: cuttingCharge.total,
      specialFeaturesCost: specialFeatureCosts.total,
      drillHoleCost: drillHoleCost.total,
      cornerStyleCost: cornerStyleCost.total,
      stringCost: stringCost.total,
      additionalOptionsCost: totalAdditionalOptions,
      serviceCharge: serviceCharge,
      deliveryCharge: deliveryCharge,
      designMyArtworkCost: designMyArtworkCost,
      netTotal: netTotal,
      markupAmount: markupAmount,
      priceExclVAT: priceExclVAT,
      vatAmount: vatAmount,
      totalPrice: priceInclVAT,
      pricePerTag: finalPricePerTag,
      totalPriceInPence: Math.round(priceInclVAT * 100),
      quantity: quantity,
      calculatedAt: new Date().toISOString()
    };
    
    if (this.form) {
      this.form.dataset.lastCalculation = JSON.stringify({
        tagWidth: width,
        tagHeight: height,
        tagsPerSheet: tagsPerSheet,
        sheetsNeeded: sheetsNeeded,
        totalPriceInPence: Math.round(priceInclVAT * 100)
      });
      
      this.form.dataset.tagWidth = width;
      this.form.dataset.tagHeight = height;
      this.form.dataset.tagsPerSheet = tagsPerSheet;
      this.form.dataset.sheetsNeeded = sheetsNeeded;
      this.form.dataset.totalPriceInPence = Math.round(priceInclVAT * 100);
    }
    
    document.dispatchEvent(new CustomEvent('calculator:complete', {
      detail: { 
        calculatorType: 'styled',
        isValid: true,
        pricing: this.getCurrentPricing(),
        lastCalculation: this.lastCalculation
      }
    }));
  }  
  
  getCurrentPricing() {
    const readiness = this.checkCalculationReadiness();
    if (!readiness || !readiness.allReady) { 
      return null;
    }
    
    if (this.lastCalculation) {
      return {
        total_display: this.formatPrice(this.lastCalculation.totalPrice),
        per_tag_display: this.formatPrice(this.lastCalculation.pricePerTag),
        currency: 'GBP',
        includes_vat: true,
        totalPriceInPence: this.lastCalculation.totalPriceInPence,
        dimensions: {
          width: this.lastCalculation.tagWidth,
          height: this.lastCalculation.tagHeight,
          unit: 'mm'
        },
        tagsPerSheet: this.lastCalculation.tagsPerSheet,
        sheetsNeeded: this.lastCalculation.sheetsNeeded,
        quantity: this.lastCalculation.quantity
      };
    }
    
    const totalPrice = this.totalPriceDisplay?.textContent;
    const pricePerTag = this.pricePerTagDisplay?.textContent;
    
    return {
      total_display: totalPrice,
      per_tag_display: pricePerTag,
      currency: 'GBP',
      includes_vat: true
    };
  }

  getCurrentPriceInPence() {
    if (this.lastCalculation?.totalPriceInPence) {
      return this.lastCalculation.totalPriceInPence;
    }
    
    if (!this.totalPriceDisplay?.textContent) return 0;
    
    const priceText = this.totalPriceDisplay.textContent;
    const priceMatch = priceText.match(/£([\d,]+\.?\d*)/);
    if (priceMatch) {
      const pounds = parseFloat(priceMatch[1].replace(',', ''));
      return Math.round(pounds * 100);
    }
    return 0;
  }

  updatePriceDisplay(basePrice, setupCosts, drillCosts, stringCosts, totalPrice, pricePerTag) {
    if (this.basePriceDisplay) {
      this.basePriceDisplay.textContent = this.formatPrice(basePrice);
    }
    
    if (this.setupCostDisplay) {
      this.setupCostDisplay.textContent = this.formatPrice(setupCosts);
    }
    
    if (this.totalPriceDisplay) {
      this.totalPriceDisplay.textContent = this.formatPrice(totalPrice);
    }
    if (this.pricePerTagDisplay) {
      this.pricePerTagDisplay.textContent = this.formatPrice(pricePerTag);
    }
  }
  
  formatPrice(price) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 2
    }).format(price);
  }
  
  showPriceDisplay() {
    if (this.priceSection) {
      this.priceSection.style.display = 'block';
    }
  }
  
  hidePriceDisplay() {
    if (this.priceSection) {
      this.priceSection.style.display = 'none';
    }
  }
  
  resetCalculator() {
    this.enableStyleTemplateFirst();
    this.resetOtherFields();
    this.hidePriceDisplay();
  }
  
  resetBaseAndDown() {
    this.baseSelect.value = '';
    this.baseSelect.disabled = true;
    this.updateSelectionState(this.baseSelect);
    this.resetMaterialAndDown();
  }
  
  resetMaterialAndDown() {
    this.materialSelect.value = '';
    if (this.originalMaterialOptions) {
      this.materialSelect.innerHTML = '';
      this.originalMaterialOptions.forEach(option => {
        this.materialSelect.appendChild(option.cloneNode(true));
      });
    }
    this.materialSelect.disabled = true;
    this.updateSelectionState(this.materialSelect);
    this.resetQuantityAndDownIncludingQuantity();
  }
  
  resetQuantityAndDown() {
    this.quantitySelect.value = '';
    this.updateSelectionState(this.quantitySelect);
    
    if (this.customQuantityField) {
      this.customQuantityField.style.display = 'none';
    }
    if (this.customQuantityInput) {
      this.customQuantityInput.value = '';
      this.customQuantityInput.disabled = true;
    }
    
    this.resetPrintOptions();
  }
  
  resetQuantityAndDownIncludingQuantity() {
    this.sizeSelect.value = '';
    this.sizeSelect.disabled = true;
    this.quantitySelect.value = '';
    this.quantitySelect.disabled = true;
    this.updateSelectionState(this.sizeSelect);
    this.updateSelectionState(this.quantitySelect);
    
    if (this.customQuantityField) {
      this.customQuantityField.style.display = 'none';
    }
    if (this.customQuantityInput) {
      this.customQuantityInput.value = '';
      this.customQuantityInput.disabled = true;
    }
    
    this.resetPrintOptions();
  }
  
  resetPrintOptions() {
    // Restore labels to default
    if (this.printSidesLabel) {
      this.printSidesLabel.textContent = this.originalLabels.printSides;
    }
    if (this.printInkLabel) {
      this.printInkLabel.textContent = this.originalLabels.printInk;
    }

    this.printSidesSelect.value = '';
    this.printSidesSelect.disabled = true;
    this.printSidesSelect.innerHTML = '<option value="" hidden>Choose Print Sides...</option>';

    this.printInkSelect.value = '';
    this.printInkSelect.disabled = true;
    this.printInkSelect.innerHTML = '<option value="" hidden>Choose Print Ink...</option>';

    this.updateSelectionState(this.printSidesSelect);
    this.updateSelectionState(this.printInkSelect);
  }
  
  resetOptionalFields() {
    if (this.drillDiameterSelect) {
      this.drillDiameterSelect.value = '';
      this.drillDiameterSelect.disabled = true;
      this.updateSelectionState(this.drillDiameterSelect);
    }
    
    if (this.drillDiameterField) {
      this.drillDiameterField.style.display = 'none';
    }
    
    if (this.stringAttachmentSelect) {
      this.stringAttachmentSelect.value = '';
      this.stringAttachmentSelect.disabled = true;
      this.updateSelectionState(this.stringAttachmentSelect);
    }
    
    if (this.stringAttachmentField) {
      this.stringAttachmentField.style.display = 'none';
    }
    
    if (this.stringTypeSelect) {
      this.stringTypeSelect.value = '';
      this.stringTypeSelect.disabled = true;
      this.updateSelectionState(this.stringTypeSelect);
    }
    
    if (this.stringTypeFieldContainer) {
      this.stringTypeFieldContainer.style.display = 'none';
    }
    
    if (this.cornerStyleSelect) {
      this.cornerStyleSelect.value = '';
      this.cornerStyleSelect.disabled = true;
      this.updateSelectionState(this.cornerStyleSelect);
    }

    if (this.cornerStyleField) {
      this.cornerStyleField.style.display = 'none';
    }
  }
  
  resetOtherFields() {
    this.resetBaseAndDown();
    this.resetOptionalFields();
  }
  
  updateSelectionState(selectElement) {
    if (!selectElement) return;
    
    const hasValidSelection = selectElement.value && 
                             selectElement.value !== "" && 
                             !selectElement.disabled;
    
    selectElement.toggleAttribute('data-has-selection', hasValidSelection);
    selectElement.classList.toggle('has-selection', hasValidSelection);
  }
  
  updateAllSelectionStates() {
    const allSelects = [
      this.shapeSelect,
      this.baseSelect,
      this.materialSelect,
      this.sizeSelect,
      this.quantitySelect,
      this.printSidesSelect,
      this.printInkSelect,
      this.drillDiameterSelect,
      this.stringAttachmentSelect,
      this.stringTypeSelect
    ];
    
    allSelects.forEach(select => {
      if (select) {
        this.updateSelectionState(select);
      }
    });
  }
  
  enableOptionalFieldsForStyleTemplate(styleOption) {
    const productType = styleOption?.dataset.productType || '';
    const normalizedType = this.normalizeProductType(productType);

    if (this.drillDiameterSelect && this.drillDiameterField) {
      if (normalizedType === 'key_card_holder') {
        this.drillDiameterField.style.display = 'none';
        this.drillDiameterSelect.value = 'none';
        this.drillDiameterSelect.disabled = true;
      } else {
        this.drillDiameterField.style.display = 'block';
        this.populateDrillDiameters();
        this.updateSelectionState(this.drillDiameterSelect);
      }
    }

    if (this.cornerStyleSelect && this.cornerStyleField) {
      const isFoldedTag = normalizedType === 'folded_tag';
      
      if (isFoldedTag) {
        this.cornerStyleField.style.display = 'block';
        this.populateCornerStyles();
        this.cornerStyleSelect.disabled = false;
        this.updateSelectionState(this.cornerStyleSelect);
      } else {
        this.cornerStyleField.style.display = 'none';
        this.cornerStyleSelect.disabled = true;
        this.cornerStyleSelect.value = '';
        this.updateSelectionState(this.cornerStyleSelect);
      }
    }
    
    if (this.stringAttachmentSelect && this.stringAttachmentField) {
      this.stringAttachmentField.style.display = 'block';
      this.stringAttachmentSelect.disabled = false;
      this.updateSelectionState(this.stringAttachmentSelect);
    }
  }
  
  normalizeProductType(productType) {
    if (!productType) return '';
    
    const normalized = productType.toLowerCase().replace(/-/g, '_');
    
    if (normalized === 'folded_tags') return 'folded_tag';
    if (normalized === 'bottleneck_tags') return 'bottle_neck_tag';
    if (normalized === 'car_hangers') return 'car_hanger';
    if (normalized === 'door_hangers') return 'door_hanger';
    if (normalized === 'swing_tags') return 'swing_tag';
    if (normalized === 'key_card_holders') return 'key_card_holder';

    return normalized;
  }

  populateDrillDiameters() {
    if (!this.drillDiameterSelect) return;
    
    const previousSelection = this.drillDiameterSelect.value;
    this.drillDiameterSelect.innerHTML = '<option value="" hidden>Choose Drill Hole...</option>';
    
    const styleOption = this.shapeSelect?.selectedOptions[0];
    const productType = styleOption?.dataset.productType || '';
    const normalizedType = this.normalizeProductType(productType);
    const isFoldedProduct = normalizedType === 'folded_tag' || normalizedType === 'bottle_neck_tag' || normalizedType === 'key_card_holder';
    
    let foundPreviousSelection = false;
    
    const noneOption = document.createElement('option');
    noneOption.value = 'none';
    noneOption.textContent = 'None';
    noneOption.dataset.setupCharge = '0';
    noneOption.dataset.pricePer1000 = '0';
    noneOption.dataset.isFolded = 'false';
    this.drillDiameterSelect.appendChild(noneOption);
    
    if (previousSelection === 'none' || previousSelection === '') {
      foundPreviousSelection = true;
    }
    
    if (isFoldedProduct && this.drillHoleFoldedData && Object.keys(this.drillHoleFoldedData).length > 0) {
      Object.keys(this.drillHoleFoldedData).forEach(key => {
        const foldedData = this.drillHoleFoldedData[key];
        
        const option = document.createElement('option');
        option.value = foldedData.handle;
        option.textContent = foldedData.display_name;
        option.dataset.setupCharge = foldedData.setup_charge;
        option.dataset.pricePer1000 = foldedData.price_per_1000;
        option.dataset.isFolded = 'true';
        
        this.drillDiameterSelect.appendChild(option);
        
        if (option.value === previousSelection) {
          foundPreviousSelection = true;
        }
      });
    } else if (this.drillDiametersData && Object.keys(this.drillDiametersData).length > 0) {
      Object.keys(this.drillDiametersData).forEach(key => {
        if (key === '0') return;
        
        const diameterData = this.drillDiametersData[key];
        
        const option = document.createElement('option');
        option.value = key;
        option.textContent = diameterData.display_name;
        option.dataset.diameterValue = diameterData.value;
        option.dataset.handle = diameterData.handle;
        option.dataset.isFolded = 'false';
        
        this.drillDiameterSelect.appendChild(option);
        
        if (option.value === previousSelection) {
          foundPreviousSelection = true;
        }
      });
    }
    
    if (foundPreviousSelection && previousSelection) {
      this.drillDiameterSelect.value = previousSelection;
    }
    
    this.drillDiameterSelect.disabled = false;
  }

  populateCornerStyles() {
    if (!this.cornerStyleSelect) return;
    
    const previousSelection = this.cornerStyleSelect.value;
    this.cornerStyleSelect.innerHTML = '<option value="" hidden>Choose Corner Style...</option>';
    
    Object.keys(this.cornerStylesData).forEach(styleCode => {
      const styleData = this.cornerStylesData[styleCode];
      
      const option = document.createElement('option');
      option.value = `corner_style_${styleCode}`;
      option.textContent = styleData.display_name;
      option.dataset.pricePerThousand = styleData.price_per_1000;
      option.dataset.setupCharge = styleData.setup_charge;
      option.dataset.styleCode = styleCode;
      
      this.cornerStyleSelect.appendChild(option);
    });
    
    if (previousSelection) {
      const stillValid = Array.from(this.cornerStyleSelect.options)
        .some(opt => opt.value === previousSelection);
      if (stillValid) {
        this.cornerStyleSelect.value = previousSelection;
      }
    }
  }

  onDrillDiameterChange() {
    if (!this.drillDiameterSelect) return;
    
    const drillValue = this.drillDiameterSelect.value;
    
    const positionField = document.getElementById('ht-drill-position-field');
    const hasValue = drillValue && drillValue !== '' && drillValue !== 'none';
    
    if (hasValue && this.drillPositionSelect) {
      if (positionField) positionField.style.display = 'block';
      
      if (this.drillPositionSelect.options.length <= 1 && this.drillPositionsData) {
        Object.entries(this.drillPositionsData).forEach(([code, pos]) => {
          const opt = document.createElement('option');
          opt.value = code;
          opt.textContent = pos.display_name;
          opt.dataset.setupCharge = pos.setup_charge;
          opt.dataset.pricePerThousand = pos.price_per_1000;
          opt.dataset.foldedPricePerThousand = pos.folded_price_per_1000;
          this.drillPositionSelect.appendChild(opt);
        });
      }
      
      this.drillPositionSelect.value = 'top_left';
      this.drillPositionSelect.disabled = true;
      
    } else if (this.drillPositionSelect) {
      if (positionField) positionField.style.display = 'none';
      this.drillPositionSelect.value = '';
      this.drillPositionSelect.disabled = true;
    }
    
    this.updateSelectionState(this.drillDiameterSelect);
    this.calculatePriceIfReady();
  }

  onCornerStyleChange() {
    if (!this.cornerStyleSelect) return;
    
    this.updateSelectionState(this.cornerStyleSelect);
    this.calculatePriceIfReady();
  }
  
  onStringAttachmentChange() {
    if (!this.stringAttachmentSelect) return;
    const selectedValue = this.stringAttachmentSelect.value;
    const isNone = !selectedValue || selectedValue === '' || 
                   selectedValue === 'none' || selectedValue.toLowerCase().includes('none');
    
    if (!isNone) {
      if (this.stringTypeFieldContainer) {
        this.stringTypeFieldContainer.style.display = 'block';
      }
      if (this.stringTypeSelect) {
        this.stringTypeSelect.disabled = false;
      }
    } else {
      if (this.stringTypeFieldContainer) {
        this.stringTypeFieldContainer.style.display = 'none';
      }
      if (this.stringTypeSelect) {
        this.stringTypeSelect.disabled = true;
        this.stringTypeSelect.value = '';
      }
    }
    
    this.updateSelectionState(this.stringAttachmentSelect);
    this.calculatePriceIfReady();
  }
  
  onStringTypeChange() {
    if (!this.stringTypeSelect) return;
    
    this.updateSelectionState(this.stringTypeSelect);
    this.calculatePriceIfReady();
  }
}

// Initialize immediately if DOM is ready, otherwise wait
 function initHTCalculatorStyled() {
   if (document.getElementById('ht-calculator-form') &&
       document.querySelector('[data-section-type*="styled"]')) {
     window.htCalculatorStyled = new HTCalculatorStyled();
     console.log('✅ HTCalculatorStyled initialized');
   }
 }

 if (document.readyState === 'loading') {
   // DOM still loading, wait for DOMContentLoaded
   document.addEventListener('DOMContentLoaded', initHTCalculatorStyled);
 } else {
   // DOM already loaded, initialize immediately
   initHTCalculatorStyled();
 }

 window.HTCalculatorStyled = HTCalculatorStyled;